module.exports = __webpack_public_path__ + "img/cc-logo.d0d8d26.svg";